import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith('ar') ? 'ar' : 'en';

  const handleChange = (_, value) => {
    if (value) {
      i18n.changeLanguage(value);
    }
  };

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={lang}
      onChange={handleChange}
      aria-label="Language"
      sx={{
        direction: 'ltr',
        '& .MuiToggleButton-root': {
          color: 'rgba(255,255,255,0.7)',
          borderColor: 'rgba(255,255,255,0.25)',
          fontFamily: 'Ubuntu, sans-serif',
          fontSize: 12,
          py: 0.25,
          px: 1,
          '&.Mui-selected': {
            color: '#fff',
            bgcolor: 'rgba(233, 84, 32, 0.35)',
            borderColor: '#e95420',
          },
          '&.Mui-selected:hover': {
            bgcolor: 'rgba(233, 84, 32, 0.45)',
          },
        },
      }}
    >
      <ToggleButton value="en" aria-label="English">
        EN
      </ToggleButton>
      <ToggleButton value="ar" aria-label="Arabic">
        AR
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default LanguageToggle;
